import React from "react";
import { motion } from "framer-motion";
import {
  FaUserPlus,
  FaChalkboardTeacher,
  FaClock,
  FaMoneyBillWave,
  FaUserShield,
  FaCopyright,
  FaExclamationTriangle,
  FaSyncAlt,
  FaEnvelope,
} from "react-icons/fa";

const Terms = () => {
  return (
    <div
      className="min-h-screen bg-gradient-to-br from-purple-100 via-white to-pink-100 flex justify-center items-center p-6"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1470&q=80')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <motion.div
        className="bg-white bg-opacity-90 backdrop-blur-xl rounded-3xl shadow-2xl max-w-4xl w-full p-10 overflow-y-auto"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="flex justify-center mb-6">
          <FaUserShield className="text-5xl text-purple-600 animate-pulse" />
        </div>
        <h1 className="text-4xl font-bold text-center text-purple-700 mb-6">
          Terms & Conditions
        </h1>

        <p className="mb-4 text-gray-700 text-center">
          Welcome to <span className="font-semibold">Vicademics</span>! By
          accessing or using our website and services, you agree to comply with
          and be bound by these terms.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-purple-600">
          <FaUserPlus /> Account Registration
        </motion.h2>
        <p className="mb-4 text-gray-700">
          To use certain features, you must create an account and provide
          accurate, complete information. You are responsible for keeping your
          credentials confidential.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-purple-600">
          <FaChalkboardTeacher /> Course Content
        </motion.h2>
        <p className="mb-4 text-gray-700">
          Instructors can upload videos, articles, and quizzes to create
          courses. Vicademics is not responsible for the accuracy or
          completeness of these courses. We reserve the right to remove content
          violating our policies.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-purple-600">
          <FaClock /> Course Access & Validity
        </motion.h2>
        <p className="mb-4 text-gray-700">
          Courses are accessible for one year from the purchase date. After this
          period, access will expire unless renewed. Learners are responsible
          for completing courses within this timeframe.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-purple-600">
          <FaMoneyBillWave /> Payments & Refunds
        </motion.h2>
        <p className="mb-4 text-gray-700">
          All payments are non-refundable unless explicitly stated in our Refund
          Policy. By purchasing, you agree to pay the listed price for the
          course.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-purple-600">
          <FaUserShield /> User Conduct
        </motion.h2>
        <p className="mb-4 text-gray-700">
          You agree not to misuse our services, including uploading harmful
          content, violating laws, or infringing intellectual property. We may
          suspend or terminate accounts violating these terms.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-purple-600">
          <FaCopyright /> Intellectual Property
        </motion.h2>
        <p className="mb-4 text-gray-700">
          All content on Vicademics, excluding user-submitted content, belongs
          to us or our licensors. You may not copy, distribute, or create
          derivative works without permission.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-purple-600">
          <FaExclamationTriangle /> Limitation of Liability
        </motion.h2>
        <p className="mb-4 text-gray-700">
          Vicademics is not liable for any indirect, incidental, or
          consequential damages from using our services.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-purple-600">
          <FaSyncAlt /> Changes to Terms
        </motion.h2>
        <p className="mb-4 text-gray-700">
          We may update these Terms & Conditions at any time. It is your
          responsibility to review them regularly. Continued use of our services
          means acceptance of changes.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-purple-600">
          <FaEnvelope /> Contact Us
        </motion.h2>
        <p className="mb-6 text-gray-700">
          For questions or concerns, contact us at{" "}
          <a
            href="mailto:support@Vicademics.com"
            className="text-purple-600 underline"
          >
            support@Vicademics.com
          </a>
          .
        </p>

        <p className="text-center text-gray-500 text-sm">
          Last updated: June 2025
        </p>
      </motion.div>
    </div>
  );
};

export default Terms;
